import _ from 'lodash';
import Config from '@skin_config';
import { getAuthData } from '@common/helpers/auth';
import { getPreferencesContextValue } from '@common/contexts/preferences';
import { fetchRequest } from '../helpers/util/requestMiddleware';

const makeCMSRequest = _.partial(fetchRequest, Config.casino.url);

class CMSApi {
  static get mainParams() {
    const [{ lang }] = getPreferencesContextValue();

    return {
      partner_id: getAuthData().pid,
      is_mobile: 1,
      lang,
    };
  }

  static getLiveCasinoGames(params = {}) {
    const queryParams = { category: 28, ...CMSApi.mainParams, ...params };
    return makeCMSRequest('getGames', 'GET', { queryParams });
  }

  static getCasinoCategories(params = {}) {
    const queryParams = { ...CMSApi.mainParams, ...params };
    return makeCMSRequest('getOptions', 'GET', { queryParams });
  }

  static getCasinoProviders(params = {}) {
    const queryParams = { ...CMSApi.mainParams, ...params };
    return makeCMSRequest('getOptions', 'GET', { queryParams });
  }

  static getCasinoGames(params = {}) {
    const queryParams = { ...CMSApi.mainParams, ...params };
    return makeCMSRequest('getGames', 'GET', { queryParams });
  }

  static getGroupedProviderOptions(params = {}) {
    const queryParams = { ...CMSApi.mainParams, ...params };
    return makeCMSRequest('getGroupedProviderOptions', 'GET', { queryParams });
  }
}

export default CMSApi;
